import { render } from "./tungsten.svg?vue&type=template&id=28707d6a?inline"
const script = {}

import exportComponent from "/build/cloudstack-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__